module.exports = __webpack_public_path__ + "media/src/website/images/contact/map-1b5ad6fcab72fea449730a2d287b9978.png";